import axios from "@/libs/api.request";
// 公共权限增删改查
export const operPubilc = params => {
  return axios.request({
    url: `/common/menu${params.id ? "/" + params.id : ""}`,
    params,
    method: params.method
  });
};
